import React from "react"
import { InputContainer, LabelRow, Label, SelectRow, FieldText, ErrorMessage } from "./common"
import { DualDropdown, SelectInput, FormInput } from "buoy-core"
import { Required } from "buoy-input"
import { formatHeight, options } from "../userDetailsUtilities"

const FutureHeight = ({ dirty, height, onChangeHeight, setUnit }) => (
  <InputContainer>
    <LabelRow>
      <Label>Height</Label>
    </LabelRow>
    {dirty ? (
      <React.Fragment>
        {height && height.unit === "ft/in" ? (
          <DualDropdown
            noMargin
            optionsLeft={options.height.feet}
            optionsRight={options.height.inches}
            onChangeLeft={onChangeHeight("feet")}
            onChangeRight={onChangeHeight("inches")}
            valueLeft={height.value.feet}
            valueRight={height.value.inches}
            placeholderLeft="5 ft"
            placeholderRight="8 in"
          />
        ) : (
          <FormInput
            placeholder="152 cm"
            value={height.value.cm}
            onChange={onChangeHeight("cm")}
          />
        )}
        <SelectRow>
          <SelectInput
            onClick={setUnit("height", "ft/in")}
            label="ft/in"
            labelledBy=""
            value="ft/in"
            name="height unit"
            selected={height.unit === "ft/in"}
          />
          <SelectInput
            onClick={setUnit("height", "cm")}
            label="cm"
            labelledBy=""
            value="cm"
            name="height unit"
            selected={height.unit === "cm"}
          />
        </SelectRow>
      </React.Fragment>
    ) : (
      <FieldText small>{formatHeight(height)}</FieldText>
    )}
  </InputContainer>
)

const Height = ({ dirty, height, onChangeHeight }) => (
  <InputContainer>
    <LabelRow>
      <Label>Height<Required /></Label>
    </LabelRow>
    {dirty ? (
      <React.Fragment>
        <DualDropdown
          noMargin
          optionsLeft={options.height.feet}
          optionsRight={options.height.inches}
          onChangeLeft={onChangeHeight("feet")}
          onChangeRight={onChangeHeight("inches")}
          valueLeft={height.value.feet}
          valueRight={height.value.inches}
          placeholderLeft="5 ft"
          placeholderRight="8 in"
        />
        {height.edited && !height.valid && <ErrorMessage>{height.error}</ErrorMessage>}
      </React.Fragment>
    ) : (
      <FieldText small>{formatHeight(height)}</FieldText>
    )}
  </InputContainer>
)

export { Height as default, FutureHeight }



// WEBPACK FOOTER //
// ./assets/account/components/forms/Height.js